import { useAtom, useSetAtom } from "jotai";
import { useCallback } from "react";
import type { ClaraEntryPoint } from "../../../../../features/ai-chatbot/constants/clara-entry-point.enum";
import { useTrackChatbotPanelOpened } from "../../../../../features/ai-chatbot/hooks/useTrackChatbotPanelOpened";
import { claraEntryPointAtom } from "../../../../../features/ai-chatbot/store/clara-entry-point.store";
import useIsMobile from "../../../../../hooks/device/useIsMobile";
import { NO_SCROLL_BODY_CLASS } from "../../../Header/Search/search-input-mobile";
import { sendChatbotPanelOpenedGtmEvent } from "../../events/chatbot-panel-opened-event";
import { chatbotOpenAtom } from "../../stores/chatbot.store";

export function useChatbotPanel() {
  const isMobile = useIsMobile();
  const [isChatbotOpen, setIsChatbotOpen] = useAtom(chatbotOpenAtom);
  const setClaraEntryPoint = useSetAtom(claraEntryPointAtom);
  const { trackPanelOpened } = useTrackChatbotPanelOpened();

  const closeChatbotPanel = useCallback(
    function closeChatbotPanel() {
      if (isMobile) {
        document.body.classList.remove(NO_SCROLL_BODY_CLASS);
      }
      setIsChatbotOpen(false);
    },
    [isMobile, setIsChatbotOpen]
  );

  const openChatbotPanel = useCallback(
    function openChatbotPanel(entryPoint?: ClaraEntryPoint) {
      if (entryPoint) {
        setClaraEntryPoint(entryPoint);
      }

      if (isChatbotOpen) {
        return;
      }

      if (isMobile) {
        document.body.classList.add(NO_SCROLL_BODY_CLASS);
      }
      setIsChatbotOpen(true);
      sendChatbotPanelOpenedGtmEvent();
      trackPanelOpened(entryPoint);
    },
    [isMobile, setIsChatbotOpen, setClaraEntryPoint, isChatbotOpen, trackPanelOpened]
  );

  return {
    isChatbotOpen,
    closeChatbotPanel,
    openChatbotPanel,
  };
}
